import { useEffect, useState } from 'react'
import type { FormEvent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { routes } from '@/routes'
import { SearchIcon } from '@/components/ui/icons'

/** Campo de busca do cabeçalho. Mantém o termo sincronizado com a URL. */
export function SearchBar() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [term, setTerm] = useState(searchParams.get('q') ?? '')

  // Voltar/avançar do navegador precisa refletir no campo.
  useEffect(() => {
    setTerm(searchParams.get('q') ?? '')
  }, [searchParams])

  function handleSubmit(event: FormEvent) {
    event.preventDefault()
    const trimmed = term.trim()
    navigate(trimmed ? routes.search(trimmed) : routes.search())
  }

  return (
    <form
      role="search"
      onSubmit={handleSubmit}
      className="relative flex min-w-0 flex-1 items-center"
    >
      <label htmlFor="site-search" className="sr-only">
        Buscar produtos
      </label>
      {/* `text-base` até `lg`: abaixo de 16px o Safari do iPhone dá zoom
          sozinho ao focar o campo e desalinha o cabeçalho inteiro. */}
      <input
        id="site-search"
        type="search"
        value={term}
        onChange={(event) => setTerm(event.target.value)}
        placeholder="Busque produtos"
        autoComplete="off"
        className="h-10 w-full rounded bg-surface pl-4 pr-11 text-base text-ink shadow-card outline-none placeholder:text-ink-faint focus:ring-2 focus:ring-white/60 lg:text-sm"
      />
      <button
        type="submit"
        aria-label="Buscar"
        className="absolute right-0 flex h-10 w-11 items-center justify-center border-l border-line text-ink-soft transition-colors hover:text-ink"
      >
        <SearchIcon className="size-[18px]" strokeWidth={2} />
      </button>
    </form>
  )
}
